import { ApiRequestConfig, apiService } from './api.service';

import { IThreadResponse } from '@/interfaces/entities/thread';
import { IApiService } from '@/interfaces/services/IApiService';

class ThreadService {
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async getAllThreads(pageNumber: number, config?: ApiRequestConfig) {
		return await this.api.get<{
			data: IThreadResponse[];
			pageCount: number;
		}>(`/thread?page[number]=${pageNumber}&sort[createdAt]=DESC`, config);
	}

	async deleteThread(id: number) {
		return await this.api.delete(`/thread/${id}`);
	}

	async changeThreadStatus(id: number, status: string) {
		return await this.api.patch(`/thread/status/${id}`, { status: status });
	}
}

export const threadService = new ThreadService(apiService);
